<template>
  <div class="view">
    <div class="content">
      <div class="auth_c">
        <div class="access_title" style="border-top: 0">
          <p>请根据业务需要配置订阅信息，客户将在对应业务场景下收到小程序订阅信息通知，配置成功后，请勿随意取消，避免影响客户体验。</p>
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column align="center" prop="sceneName" label="使用场景"></el-table-column>
          <el-table-column align="center" prop="title" label="标题">
            <template slot-scope="scope">
              <span class="whd-gray999" v-if="!scope.row.templateId">待配置</span>
              <template v-else>{{scope.row.title}}</template>
            </template>
          </el-table-column>
          <el-table-column align="center" label="关键词">
            <template slot-scope="scope">
              <span class="whd-gray999" v-if="!scope.row.templateId">待配置</span>  
              <template v-else>
                <span v-for="(item,index) in scope.row.keywords" :key="item.kid"><template v-if="index!=0">，</template>{{item.name}}</span>
              </template>             
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sceneDesc" label="场景描述">
            <template slot-scope="scope">
              <span class="whd-gray999" v-if="!scope.row.templateId">待配置</span>
              <template v-else>{{scope.row.sceneDesc}}</template>
            </template>
          </el-table-column>
          <el-table-column align="center" prop label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.templateId" class="red" type="text" size="small" @click="delConf(scope.row.templateId)">停用</el-button>
              <el-button v-else  type="text" size="small" @click="configuration(scope.row.id,scope.row.sceneName)">配置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/api.js";
export default {
  name: "subscribePannel",
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    InitFn() {
      this.axios
          .post(api.subscribe_message_list, {})
          .then(response => {
            if (response.data.code == 0) {
              this.tableData = response.data.list;
            } else {
            }
          })
          .catch(response => {
          });
    },
    // 配置
    configuration(id,title) {
      this.axios
          .post(api.subscribe_config, {id: id})
          .then(response => {
            if (response.data.code == 0) {
              this.InitFn();
            } else if (response.data.code == 2){
              let that = this;
              setTimeout(function(){
                that.$router.push({'name': 'miniappPannelEdit'});
              }, 2000) 
            } else { 
              if (response.data.msg === "未找到符合的模板标题") {
                const str = `【${title}】`;  
                this.$msgbox({
                  showClose: false,
                  confirmButtonText: '知道了',
                  dangerouslyUseHTMLString: true,
                  customClass: "whd-msgbox-html",
                  message: '<span class="tit"><i class="el-icon-warning"></i>提示</span><span class="cont">'+ str +'在你企业当前的小程序类目下未有对应模板，请登录<a href="https://mp.weixin.qq.com/" target="_blank">微信公众平台</a>添加小程序服务类目，再配置该消息。</span><span class="cont">注意：因不同服务类目可用消息模板不同，如想使用所有模板，建议添加【商家自营】下的二级类目，【美妆洗护】、【服装/鞋/箱包】、【家电】、【珠宝】，任意添加一个，即可获取对应模板。</span>' 
                }).catch(action => {

                });
              }
            }
          })
          .catch(response => {
          });      
    },
    // 删除
    delConf(option) {
      this.$confirm('若停用该订阅配置，客户将不会在对应业务场景下收到小程序订阅信息通知', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios
            .post(api.subscribe_message_del_template, {priTmplId: option})
            .then(response => {
              if (response.data.code == 0) {
                this.$message.success(response.data.msg);
                this.InitFn();
              } 
            })
            .catch(response => {
            });
        }).catch(() => {
        
        });      
    }
  }
}
</script>